/* 🤖 this file was generated by svg-to-ts */
export const matIconPolymer: {
  name: 'polymer';
  data: string;
} = {
  name: 'polymer',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8L19 4z"/></svg>`
};
